import React from "react";
import "./fab.css";

/**
 * FAB with optional speed-dial.
 * Backward-compatible:
 *   <Fab icon={IoMdAdd} onClick={...} />        single action (legacy)
 *   <Fab actions={[{icon, label, onClick}, …]} /> expandable speed-dial
 */
export default function Fab(props) {
  const [open, setOpen] = React.useState(false);
  const isSpeedDial = Array.isArray(props.actions) && props.actions.length > 0;

  // Close on outside click or Escape
  React.useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (!e.target.closest || !e.target.closest(".fab")) setOpen(false);
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("click", onClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  if (!isSpeedDial) {
    return (
      <div className="fab" onClick={props.onClick}>
        <span>
          <props.icon />
        </span>
      </div>
    );
  }

  const Icon = props.icon;

  return (
    <div className={`fab fab--dial ${open ? "fab--open" : ""}`}>
      {open && (
        <div className="fab__actions">
          {props.actions.map((a, i) => {
            const ActionIcon = a.icon;
            return (
              <button
                key={i}
                type="button"
                className="fab__action"
                style={{ animationDelay: `${i * 0.04}s` }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                  a.onClick && a.onClick();
                }}
              >
                <div className="fab__action-label">{a.label}</div>
                <div className="fab__action-icon">
                  <ActionIcon />
                </div>
              </button>
            );
          })}
        </div>
      )}
      <button
        type="button"
        className="fab__trigger"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        aria-expanded={open}
      >
        <div className="fab__trigger-icon">
          <Icon />
        </div>
      </button>
    </div>
  );
}
